<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useRoute } from 'vue-router'

import TheTitle from '@/components/atoms/TheTitle.vue'
import FilterSettings from '@/components/molecules/FilterSettings.vue'
import ModalScanQR from '@/components/molecules/ModalScanQR.vue'
import TheHeader from '@/components/molecules/TheHeader.vue'
import ThePermissions from '@/components/molecules/ThePermissions.vue'
import GLFilter from '@/components/organisms/GLFilter.vue'
import PageLayout from '@/components/organisms/PageLayout.vue'
import ShareSnapshot from '@/components/organisms/ShareSnapshot.vue'
import {
  // getSeoImageUrl,
  useSeo
} from '@/composables/useHead'
import { useStoreModalState } from '@/composables/useStoreModalState'
import { useStoreWebcam } from '@/composables/useStoreWebcam'
import { getAssetURL } from '@/utils'
import { useStoreSnapshot } from '@/webgl/composables/useStoreSnapshot'

export default defineComponent({
  name: 'HomePage',
  components: {
    PageLayout,
    GLFilter,
    FilterSettings,
    ShareSnapshot,
    TheHeader,
    ModalScanQR,
    ThePermissions,
    TheTitle
  },
  props: {
    //
  },
  setup (props) {
    const { snapped } = useStoreSnapshot()
    const { modalState } = useStoreModalState()
    const { webcamState, toggleWebcam } = useStoreWebcam()

    const route = useRoute()

    const isTabletInStore = computed(() => route.query.ver?.includes('store'))

    useSeo({
      title: () => 'Home',
      description: () => 'Discover the Italian charm with the magic of Capri'
      // ogImage: () => getSeoImageUrl(DATA_FROM_CMS || 'STATIC_IMAGE_PATH')
    })

    // watchEffect(() => {
    //   const debug = {
    //     snapshot: snapped.value,
    //     camera: webcamState.value,
    //     modal: modalState.value,
    //     isStore: isTabletInStore.value
    //   }
    //   console.log(debug)
    // })

    return {
      snapped,
      modalState,
      isTabletInStore,
      getAssetURL,
      webcamState,
      toggleWebcam
    }
  }
})
</script>

<template>
  <PageLayout>
    <TheHeader />

    <div
      class="ctn-interface relative top-0 left-0 flex flex-col max-h-sview h-sview w-full overflow-hidden"
      :class="{ 'pointer-events-none': webcamState && !snapped }"
    >
      <TheTitle v-if="!webcamState" />

      <ShareSnapshot v-if="snapped" :in-store="isTabletInStore ? isTabletInStore : false" />
    </div>

    <ModalScanQR v-if="isTabletInStore && modalState" />

    <ThePermissions :denied="!webcamState" />

    <GLFilter :is-camera-enabled="webcamState && !snapped">
      <FilterSettings v-if="webcamState && !snapped" />
    </GLFilter>
  </PageLayout>
</template>

<style lang="scss" scoped>
.ctn-interface {
 z-index: $z-content;
}
</style>
